import * as _ from "lodash";
import * as angular from "angular";
import { CampaignDataProvider } from "../../data-provider/campaign.dp";
import { VoterFileDataProvider } from "../../data-provider/voter-file.dp";
import { VoterFile } from "../../models/voter-file.model";
import { VoterFileImport } from "../../models/voter-file-import.model";
import { DialogUtils } from "../../helper/dialog.helper";

let VoterFileProgressLeaderComponent = {
    selector: "vcVoterFileProgressLeader",
    templateUrl:
        "/angular/components/voter-file/voter-file-progress-leader.component.html",
    bindings: {
        selectedImid: "=",
    },
    controller: class VoterFileProgressLeaderController {
        // * bindings for typescript compiler *
        public selectedImid: string | number;
        // ************************************

        private readonly dialog: DialogUtils;
        private modelsUtils: any;
        private readonly dataProvider: VoterFileDataProvider;
        private readonly campaignDataProvider: CampaignDataProvider;
        private $window: any;
        private readonly $interval: any;
        public readonly __env: any;

        public importVersions: any = [];
        public reloading: boolean;
        public loading: boolean;
        public campaignImports: VoterFileImport[];
        public inProgress: VoterFileImport[];
        private reloadCampaignImports: any;

        public stats?: any;

        constructor(
            DialogUtils: DialogUtils,
            VoterFileDataProvider: VoterFileDataProvider,
            CampaignDataProvider: CampaignDataProvider,
            $window: any,
            $interval: any,
            __env: any,
            ModelsUtils: any
        ) {
            this.dialog = DialogUtils;
            this.modelsUtils = ModelsUtils;
            this.dataProvider = VoterFileDataProvider;
            this.campaignDataProvider = CampaignDataProvider;
            this.$window = $window;
            this.$interval = $interval;
            this.__env = __env;
        }

        $onInit() {
            if (this.selectedImid) {
                this.loadCampaignImports(false);

                this.reloadCampaignImports = this.$interval(() => {
                    this.loadCampaignImports(true);
                }, 5000);
            }
        }

        viewAccountImport(
            campaignid: string | number,
            campaignImport: VoterFileImport
        ): void {
            this.campaignDataProvider
                .changeLiveCampaign({
                    campaignid: campaignid,
                })
                .then(() => {
                    this.$window.location = `/#/voterfiles/info/${campaignImport.erid}/${campaignImport.imid}`;
                });
        }

        loadCampaignImports(reloading?: boolean): void {
            if (reloading) {
                this.reloading = true;
            } else {
                this.loading = true;
            }
            this.dataProvider
                .leaderImportProgress(this.selectedImid)
                .then((campaignImports: object[]) => {
                    if (reloading) {
                        this.reloading = false;
                    } else {
                        this.loading = false;
                    }
                    let imports = [];

                    angular.forEach(
                        campaignImports,
                        (campaignImport: object) => {
                            imports.push(
                                this.modelsUtils.import(campaignImport)
                            );
                        }
                    );

                    this.campaignImports = imports;
                });
        }
    },
};

angular
    .module("voterFile")
    .component(
        VoterFileProgressLeaderComponent.selector,
        VoterFileProgressLeaderComponent
    );
